module.exports = __webpack_public_path__ + "static/media/viva-la-vulvaXnana.b042b051.png";